import { makeStyles } from '@mui/styles';
import { EstateWorkItem, EstateWorkItemSubStatus } from 'queries';

import FormSelectField from 'common/form-select-field';
import { getEstateWorkItemSubStatusOptions } from 'utils/estate-work-item';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
}));

type EstateWorkItemSubStatusSelectProps = {
  estateWorkItem: EstateWorkItem;
  onUpdateEstateWorkItemSubStatus: (subStatus: EstateWorkItemSubStatus) => Promise<void>;
};

const EstateWorkItemSubStatusSelect = ({
  estateWorkItem,
  onUpdateEstateWorkItemSubStatus,
}: EstateWorkItemSubStatusSelectProps) => {
  const classes = useStyles();

  const onChange = (subStatus: EstateWorkItemSubStatus) => {
    onUpdateEstateWorkItemSubStatus(subStatus);
  };

  return (
    <div className={classes.container}>
      <FormSelectField
        options={getEstateWorkItemSubStatusOptions(estateWorkItem.status)}
        value={estateWorkItem.subStatus}
        onChange={(evt) => onChange(evt.target.value as EstateWorkItemSubStatus)}
      />
    </div>
  );
};

export default EstateWorkItemSubStatusSelect;
